import React, { FC } from 'react';
import { useParams } from 'react-router';
import Edit from 'components/fields/components/Edit';

const Screen: FC = () => {
  const { id } = useParams<{ id: string | undefined }>();

  return (
    <Edit
      fieldsEntityName="client-fields"
      fieldsEntityEndpoint={`client-fields?id=${id}`}
      fieldsDropdownsEntityName="client-field-dropdowns"
      fieldsDropdownsEntityEndpoint="client-fields/dropdown-options"
    />
  );
};

export default Screen;
